import { render, staticRenderFns } from "./restaurantBranchTable.vue?vue&type=template&id=9ba4cfbe&"
import script from "./restaurantBranchTable.vue?vue&type=script&lang=js&"
export * from "./restaurantBranchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports